import { render } from "./SubmitDocs.vue?vue&type=template&id=2d8bf7bd&scoped=true&ts=true"
import script from "./SubmitDocs.vue?vue&type=script&lang=ts"
export * from "./SubmitDocs.vue?vue&type=script&lang=ts"

import "./SubmitDocs.vue?vue&type=style&index=0&id=2d8bf7bd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8bf7bd"],['__file',"src/components/kyc/SubmitDocs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d8bf7bd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d8bf7bd', __exports__)) {
    api.reload('2d8bf7bd', __exports__)
  }
  
  module.hot.accept("./SubmitDocs.vue?vue&type=template&id=2d8bf7bd&scoped=true&ts=true", () => {
    api.rerender('2d8bf7bd', render)
  })

}


export default __exports__